module.exports = __webpack_public_path__ + "img/facts_1924.7779f149.jpg";